export default "__VITE_ASSET__JgTdzR7d__"